import { render, staticRenderFns } from "./AddStockToShelf.vue?vue&type=template&id=36a366a8&"
import script from "./AddStockToShelf.vue?vue&type=script&lang=js&"
export * from "./AddStockToShelf.vue?vue&type=script&lang=js&"
import style0 from "./AddStockToShelf.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports